import { createContext, useContext, useState } from 'react';
import { translations } from '@/i18n/translations';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem('pdi-lang') || 'en');

  const setLang = (l) => {
    localStorage.setItem('pdi-lang', l);
    setLangState(l);
  };

  const t = translations[lang] || translations.en;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, locale: lang === 'hi' ? 'hi-IN' : 'en-IN' }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
